import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.25C6.615 2.25 2.25 6.615 2.25 12C2.25 17.385 6.615 21.75 12 21.75C17.385 21.75 21.75 17.385 21.75 12C21.75 6.615 17.385 2.25 12 2.25ZM12 10.875C11.7016 10.875 11.4155 10.9935 11.2045 11.2045C10.9935 11.4155 10.875 11.7016 10.875 12C10.875 12.2984 10.9935 12.5845 11.2045 12.7955C11.4155 13.0065 11.7016 13.125 12 13.125C12.2984 13.125 12.5845 13.0065 12.7955 12.7955C13.0065 12.5845 13.125 12.2984 13.125 12C13.125 11.7016 13.0065 11.4155 12.7955 11.2045C12.5845 10.9935 12.2984 10.875 12 10.875ZM15.375 12C15.375 11.7016 15.4935 11.4155 15.7045 11.2045C15.9155 10.9935 16.2016 10.875 16.5 10.875C16.7984 10.875 17.0845 10.9935 17.2955 11.2045C17.5065 11.4155 17.625 11.7016 17.625 12C17.625 12.2984 17.5065 12.5845 17.2955 12.7955C17.0845 13.0065 16.7984 13.125 16.5 13.125C16.2016 13.125 15.9155 13.0065 15.7045 12.7955C15.4935 12.5845 15.375 12.2984 15.375 12ZM7.5 10.875C7.20163 10.875 6.91548 10.9935 6.7045 11.2045C6.49353 11.4155 6.375 11.7016 6.375 12C6.375 12.2984 6.49353 12.5845 6.7045 12.7955C6.91548 13.0065 7.20163 13.125 7.5 13.125C7.79837 13.125 8.08452 13.0065 8.2955 12.7955C8.50647 12.5845 8.625 12.2984 8.625 12C8.625 11.7016 8.50647 11.4155 8.2955 11.2045C8.08452 10.9935 7.79837 10.875 7.5 10.875Z"
        fill={colorValue}
      />
    </svg>
  );
};
